import request from 'services/request';

export async function salesGoalsMassiveUpload({ cancelToken, data }) {
  let uri = `/Catalogs/Api/v1/SalesGoals/MassLoadExcel`;
  return request(uri, {
    method: 'POST',
    cancelToken,
    data,
  });
}
